// 1. Use lowercase for all ISO codes
// 2. Ensure the country code matches ISO standard (to work with Shopify)
// 3. defaultCountry should be set for each language

export const languages = [
	{id: 'en', title: 'English', isDefault: true, defaultCountry: 'nl'},
]

/**
 *
 * Note:
 *
 * This array is specific to the list of countries that we want to localize for Sanity,
 * additional countries are managed from Shopify Markets.
 *
 * VALID_COUNTRY_IDS (exhaustive list from Shopify) will always include these countries,
 * however it does not reflect the store's current Market settings.
 *
 * For the purpose of locale validation, we can use this and rely on Markets
 * automatically falling back where required.
 *
 */

export const countries = [
	{
		id: 'nl',
		title: 'Netherlands',
		currency: {
			isoCode: 'EUR',
			symbol: '€',
		},
		languages: [
			{isoCode: 'nl'},
			{isoCode: 'en'},
		],
		isDefault: true,
	},
]

export const locales = languages.flatMap((lang) => {
	const matchingCountries = countries.filter(country => country.languages.map(lang => lang.isoCode).includes(lang.id))

	return matchingCountries.map((country) => {
		return {
			id: `${lang.id}-${country.id}`,
			title: `${lang.title} (${country.id.toUpperCase()})`,
			currency: country.currency,
			isDefault: lang.isDefault && lang.defaultCountry === country.id,
		}
	})
})

export const defaultLanguage = languages.find(l => l.isDefault)
export const otherLanguages = languages.filter(l => !l.isDefault)
export const defaultLanguageId = defaultLanguage.id
export const languageIds = languages.map(lang => lang.id)

export const defaultCountry = countries.find(l => l.isDefault)
export const otherCountry = countries.filter(l => !l.isDefault)
export const defaultCountryId = defaultCountry.id
export const countryIds = countries.map(country => country.id)

export const defaultLocale = locales.find(l => l.isDefault)
export const otherLocale = locales.filter(l => !l.isDefault)
export const defaultLocaleId = defaultLocale?.id || locales[0].id
export const localeIds = locales.map(locale => locale.id)

// mapped to lowercase for consistency
export const VALID_COUNTRY_IDS = [
	'ac',
	'ad',
	'ae',
	'af',
	'ag',
	'ai',
	'al',
	'am',
	'an',
	'ao',
	'ar',
	'at',
	'au',
	'aw',
	'ax',
	'az',
	'ba',
	'bb',
	'bd',
	'be',
	'bf',
	'bg',
	'bh',
	'bi',
	'bj',
	'bl',
	'bm',
	'bn',
	'bo',
	'bq',
	'br',
	'bs',
	'bt',
	'bv',
	'bw',
	'by',
	'bz',
	'ca',
	'cc',
	'cd',
	'cf',
	'cg',
	'ch',
	'ci',
	'ck',
	'cl',
	'cm',
	'cn',
	'co',
	'cr',
	'cu',
	'cv',
	'cw',
	'cx',
	'cy',
	'cz',
	'de',
	'dj',
	'dk',
	'dm',
	'do',
	'dz',
	'ec',
	'ee',
	'eg',
	'eh',
	'er',
	'es',
	'et',
	'fi',
	'fj',
	'fk',
	'fo',
	'fr',
	'ga',
	'gb',
	'gd',
	'ge',
	'gf',
	'gg',
	'gh',
	'gi',
	'gl',
	'gm',
	'gn',
	'gp',
	'gq',
	'gr',
	'gs',
	'gt',
	'gw',
	'gy',
	'hk',
	'hm',
	'hn',
	'hr',
	'ht',
	'hu',
	'id',
	'ie',
	'il',
	'im',
	'in',
	'io',
	'iq',
	'ir',
	'is',
	'it',
	'je',
	'jm',
	'jo',
	'jp',
	'ke',
	'kg',
	'kh',
	'ki',
	'km',
	'kn',
	'kp',
	'kr',
	'kw',
	'ky',
	'kz',
	'la',
	'lb',
	'lc',
	'li',
	'lk',
	'lr',
	'ls',
	'lt',
	'lu',
	'lv',
	'ly',
	'ma',
	'mc',
	'md',
	'me',
	'mf',
	'mg',
	'mk',
	'ml',
	'mm',
	'mn',
	'mo',
	'mq',
	'mr',
	'ms',
	'mt',
	'mu',
	'mv',
	'mw',
	'mx',
	'my',
	'mz',
	'na',
	'nc',
	'ne',
	'nf',
	'ng',
	'ni',
	'nl',
	'no',
	'np',
	'nr',
	'nu',
	'nz',
	'om',
	'pa',
	'pe',
	'pf',
	'pg',
	'ph',
	'pk',
	'pl',
	'pm',
	'pn',
	'ps',
	'pt',
	'py',
	'qa',
	're',
	'ro',
	'rs',
	'ru',
	'rw',
	'sa',
	'sb',
	'sc',
	'sd',
	'se',
	'sg',
	'sh',
	'si',
	'sj',
	'sk',
	'sl',
	'sm',
	'sn',
	'so',
	'sr',
	'ss',
	'st',
	'sv',
	'sx',
	'sy',
	'sz',
	'ta',
	'tc',
	'td',
	'tf',
	'tg',
	'th',
	'tj',
	'tk',
	'tl',
	'tm',
	'tn',
	'to',
	'tr',
	'tt',
	'tv',
	'tw',
	'tz',
	'ua',
	'ug',
	'um',
	'us',
	'uy',
	'uz',
	'va',
	'vc',
	've',
	'vg',
	'vn',
	'vu',
	'wf',
	'ws',
	'xk',
	'ye',
	'yt',
	'za',
	'zm',
	'zw',
]
